module.exports = __webpack_public_path__ + "img/hourglass.b89fb9e3.svg";